<script>
    import { _ } from "svelte-i18n";
  </script>

<!-- GALLERY IMAGES & INFO -->
<section class="text-gray-600 body-font">
    <div class="container px-5 py-24 mx-auto">
      <div class="flex flex-col text-center w-full mb-20">
        <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">{$_("photos.title", {
            default: "Galleria fotogarfica",
          })}</h1>
        <p class="lg:w-2/3 mx-auto leading-relaxed text-base">{$_("photos.subtitle", {
          default: "Ecco alcune foto ritraenti la nostra azienda e tutto quello che ne fa parte.",
        })}</p>
      </div>

      <div class="flex flex-wrap md:-m-2 -m-1">
        <div class="flex flex-wrap w-1/2">
          <div class="md:p-2 p-1 w-1/2">
            <img alt="gallery" class="w-full object-cover h-full object-center block" src="images/gallery/gallery11.jpg">
          </div>
          <div class="md:p-2 p-1 w-1/2">
            <img alt="gallery" class="w-full object-cover h-full object-center block" src="images/gallery/gallery6.jpg">
          </div>
          <div class="md:p-2 p-1 w-full">
            <img alt="gallery" class="w-full h-full object-cover object-center block" src="images/gallery/gallery7.jpg">
          </div>
        </div>
        <div class="flex flex-wrap w-1/2">
          <div class="md:p-2 p-1 w-full">
            <img alt="gallery" class="w-full h-full object-cover object-center block" src="images/gallery/gallery4.jpg">
          </div>
          <div class="md:p-2 p-1 w-1/2">
            <img alt="gallery" class="w-full object-cover h-full object-center block" src="images/gallery/gallery19.jpg">
          </div>
          <div class="md:p-2 p-1 w-1/2">
            <img alt="gallery" class="w-full object-cover h-full object-center block" src="images/gallery/gallery15.jpg">
          </div>
        </div>
      </div>


      <div class="flex flex-wrap -m-4 mt-1 mb-1">
        <div class="lg:w-1/3 sm:w-1/2 p-4">
          <div class="flex relative">
            <img alt="gallery" class="w-full object-cover h-full object-center block" src="images/gallery/gallery2.jpg">
          </div>
        </div>
  
        <div class="lg:w-1/3 sm:w-1/2 p-4">
          <div class="flex relative">
            <img alt="gallery" class="w-full object-cover h-full object-center block" src="images/gallery/gallery14.jpg">
          </div>
        </div>
  
        <div class="lg:w-1/3 sm:w-1/2 p-4">
          <div class="flex relative">
            <img alt="gallery" class="w-full object-cover h-full object-center block" src="images/gallery/gallery18.jpg">
          </div>
        </div>
      </div>



      <div class="flex flex-wrap md:-m-2 -m-1">
        <div class="flex flex-wrap w-1/2">
          <div class="md:p-2 p-1 w-1/2">
            <img alt="gallery" class="w-full object-cover h-full object-center block" src="images/gallery/gallery12.jpg">
          </div>
          <div class="md:p-2 p-1 w-1/2">
            <img alt="gallery" class="w-full object-cover h-full object-center block" src="images/gallery/gallery9.jpg">
          </div>
          <div class="md:p-2 p-1 w-full">
            <img alt="gallery" class="w-full h-full object-cover object-center block" src="images/gallery/gallery8.jpg">
          </div>
        </div>
        <div class="flex flex-wrap w-1/2">
          <div class="md:p-2 p-1 w-full">
            <img alt="gallery" class="w-full h-full object-cover object-center block" src="images/gallery/gallery10.jpg">
          </div>
          <div class="md:p-2 p-1 w-1/2">
            <img alt="gallery" class="w-full object-cover h-full object-center block" src="images/gallery/gallery13.jpg">
          </div>
          <div class="md:p-2 p-1 w-1/2">
            <img alt="gallery" class="w-full object-cover h-full object-center block" src="images/gallery/gallery17.jpg">
          </div>
        </div>
      </div>

    </div>
  </section>